import {
    MDBBtn,
    MDBModal,
    MDBModalBody,
    MDBModalContent,
    MDBModalDialog,
    MDBModalFooter
} from 'mdb-react-ui-kit';

import React, { useContext } from "react";
import Contact from './Contact';
import { MiscContext } from '../context/MiscProvider';

export default function ContactModal() {
    const { contactPage, setContactPage } = useContext(MiscContext);
  
    return (
        
            <MDBModal    className='mt-1'  size='sm'
                staticBackdrop={true}
                closeOnEsc={true}
                animationDirection='right'
                open={contactPage}
            >
                  <MDBModalDialog  size='xl'>
                    <MDBModalContent >
                        <MDBModalBody>
                            <Contact/>
                        </MDBModalBody>
                        <MDBModalFooter>
                    <MDBBtn
                        className='ms-auto'
                        color='dark'
                        
                        onClick={() => {
                            setContactPage(!contactPage); // Toggle the value
                            console.log(contactPage); // This will still log the previous value due to closure
                        }}
                    >
                        x
                    </MDBBtn>
                </MDBModalFooter>
                    </MDBModalContent>
                    </MDBModalDialog>
            
               
            </MDBModal>
        
    );
}
